 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsHandleWaiting~EditQuestion~EditTemplate~TicketsCl~fb6380a6":"AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsHandleWaiting~EditQuestion~EditTemplate~TicketsCl~fb6380a6","EditQuestion~EditTemplate~createTicket":"EditQuestion~EditTemplate~createTicket","EditQuestion":"EditQuestion","createQuestion":"createQuestion","AllTicketsDoing":"AllTicketsDoing","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~Configura~51d5c5cc":"AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~Configura~51d5c5cc","ConfigurationTemplate":"ConfigurationTemplate","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~EditTempl~3961e794":"AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~EditTempl~3961e794","createTicket":"createTicket","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~TicketsCl~ead2e428":"AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~TicketsCl~ead2e428","AllTicketsClaimWaiting":"AllTicketsClaimWaiting","AllTicketsDelayed":"AllTicketsDelayed","AllTicketsHandleWaiting":"AllTicketsHandleWaiting","TicketsClaimWaiting":"TicketsClaimWaiting","TicketsDelayed":"TicketsDelayed","TicketsHandleWaiting":"TicketsHandleWaiting","EditTemplate":"EditTemplate","AllTicketsDone":"AllTicketsDone","AllTickets~Dashboard~createQuickly":"AllTickets~Dashboard~createQuickly","AllTickets":"AllTickets","TicketsDone":"TicketsDone","Home":"Home","Onduty":"Onduty","Dashboard~TestEcharts":"Dashboard~TestEcharts","Dashboard":"Dashboard","createQuickly":"createQuickly","AllocationTags":"AllocationTags","TestEcharts":"TestEcharts","QuestionPanel":"QuestionPanel","Tag":"Tag","TagEdit~TagNew":"TagEdit~TagNew","TagEdit":"TagEdit","TagNew":"TagNew","TheContainer":"TheContainer","TicketView":"TicketView","TicketsDoing":"TicketsDoing","person":"person"}[chunkId]||chunkId) + "." + {"AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsHandleWaiting~EditQuestion~EditTemplate~TicketsCl~fb6380a6":"e0fe9b34","EditQuestion~EditTemplate~createTicket":"981bbeb6","EditQuestion":"14f712f8","createQuestion":"75aaa938","AllTicketsDoing":"0114a28d","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~Configura~51d5c5cc":"dc180fea","ConfigurationTemplate":"31db3161","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~EditTempl~3961e794":"583c85e3","createTicket":"13e5c048","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~TicketsCl~ead2e428":"a16a68a3","AllTicketsClaimWaiting":"21e8beaf","AllTicketsDelayed":"f8e96e7a","AllTicketsHandleWaiting":"d63f0cb9","TicketsClaimWaiting":"6ed51215","TicketsDelayed":"9c552f75","TicketsHandleWaiting":"66487894","EditTemplate":"9470da02","AllTicketsDone":"54603823","AllTickets~Dashboard~createQuickly":"bd6935d3","AllTickets":"ebadf449","TicketsDone":"53fefed0","Home":"51afd856","Onduty":"64b72a7d","Dashboard~TestEcharts":"504cfdad","Dashboard":"9c793c4e","createQuickly":"5c920243","AllocationTags":"f974c803","TestEcharts":"992eb568","QuestionPanel":"149d772a","Tag":"7c23acdd","TagEdit~TagNew":"b8cc3418","TagEdit":"fd3f343a","TagNew":"141947c9","TheContainer":"a1abc1d0","TicketView":"d4f6bdcf","TicketsDoing":"e0cf644d","person":"ffc22f79"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsHandleWaiting~EditQuestion~EditTemplate~TicketsCl~fb6380a6":1,"EditQuestion~EditTemplate~createTicket":1,"EditQuestion":1,"createQuestion":1,"AllTicketsDoing":1,"ConfigurationTemplate":1,"createTicket":1,"AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~TicketsCl~ead2e428":1,"AllTicketsClaimWaiting":1,"AllTicketsDelayed":1,"AllTicketsHandleWaiting":1,"TicketsClaimWaiting":1,"TicketsDelayed":1,"TicketsHandleWaiting":1,"EditTemplate":1,"AllTicketsDone":1,"AllTickets":1,"TicketsDone":1,"Home":1,"Onduty":1,"Dashboard~TestEcharts":1,"Dashboard":1,"createQuickly":1,"AllocationTags":1,"TestEcharts":1,"QuestionPanel":1,"Tag":1,"TagEdit":1,"TagNew":1,"TheContainer":1,"TicketView":1,"TicketsDoing":1,"person":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsHandleWaiting~EditQuestion~EditTemplate~TicketsCl~fb6380a6":"AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsHandleWaiting~EditQuestion~EditTemplate~TicketsCl~fb6380a6","EditQuestion~EditTemplate~createTicket":"EditQuestion~EditTemplate~createTicket","EditQuestion":"EditQuestion","createQuestion":"createQuestion","AllTicketsDoing":"AllTicketsDoing","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~Configura~51d5c5cc":"AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~Configura~51d5c5cc","ConfigurationTemplate":"ConfigurationTemplate","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~EditTempl~3961e794":"AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~EditTempl~3961e794","createTicket":"createTicket","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~TicketsCl~ead2e428":"AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~TicketsCl~ead2e428","AllTicketsClaimWaiting":"AllTicketsClaimWaiting","AllTicketsDelayed":"AllTicketsDelayed","AllTicketsHandleWaiting":"AllTicketsHandleWaiting","TicketsClaimWaiting":"TicketsClaimWaiting","TicketsDelayed":"TicketsDelayed","TicketsHandleWaiting":"TicketsHandleWaiting","EditTemplate":"EditTemplate","AllTicketsDone":"AllTicketsDone","AllTickets~Dashboard~createQuickly":"AllTickets~Dashboard~createQuickly","AllTickets":"AllTickets","TicketsDone":"TicketsDone","Home":"Home","Onduty":"Onduty","Dashboard~TestEcharts":"Dashboard~TestEcharts","Dashboard":"Dashboard","createQuickly":"createQuickly","AllocationTags":"AllocationTags","TestEcharts":"TestEcharts","QuestionPanel":"QuestionPanel","Tag":"Tag","TagEdit~TagNew":"TagEdit~TagNew","TagEdit":"TagEdit","TagNew":"TagNew","TheContainer":"TheContainer","TicketView":"TicketView","TicketsDoing":"TicketsDoing","person":"person"}[chunkId]||chunkId) + "." + {"AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsHandleWaiting~EditQuestion~EditTemplate~TicketsCl~fb6380a6":"702a0ab5","EditQuestion~EditTemplate~createTicket":"eca91fd4","EditQuestion":"7d6fb64c","createQuestion":"02d70bbc","AllTicketsDoing":"6ce8369a","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~Configura~51d5c5cc":"31d6cfe0","ConfigurationTemplate":"0e88f33e","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~EditTempl~3961e794":"31d6cfe0","createTicket":"5c0ddb67","AllTickets~AllTicketsClaimWaiting~AllTicketsDelayed~AllTicketsDone~AllTicketsHandleWaiting~TicketsCl~ead2e428":"35df36b9","AllTicketsClaimWaiting":"dd74e669","AllTicketsDelayed":"3a88e9ab","AllTicketsHandleWaiting":"4ef9f539","TicketsClaimWaiting":"27bb96ac","TicketsDelayed":"9f130bca","TicketsHandleWaiting":"d29cac1c","EditTemplate":"077c3cd4","AllTicketsDone":"e8f7953e","AllTickets~Dashboard~createQuickly":"31d6cfe0","AllTickets":"a307117d","TicketsDone":"b140edbc","Home":"2820ee94","Onduty":"ef509ffd","Dashboard~TestEcharts":"5c82d544","Dashboard":"fbf641ab","createQuickly":"0cf5277d","AllocationTags":"208c424c","TestEcharts":"0e433876","QuestionPanel":"f0f3ea29","Tag":"fb81fe1f","TagEdit~TagNew":"31d6cfe0","TagEdit":"26c4a701","TagNew":"5deeebc4","TheContainer":"b8f21f57","TicketView":"e4b7b840","TicketsDoing":"8f9c1cb0","person":"ab9ebd07"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
